<footer class="text-gray-400 body-font">
  <div
    class="container px-5 pt-8 pb-4 mx-auto flex items-center sm:flex-row flex-col"
  >
    <p class="text-sm text-gray-400 sm:py-2 sm:mt-0 mt-4">
      © {{ year }} {{ copyrightHolderName }}
    </p>
    <span
      class="inline-flex text-sm sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start"
    >
      <a class="ml-3 text-gray-400" [href]="termsUrl" target="_blank"
        >Terms of Service</a
      >
      <a class="ml-3 text-gray-400" [href]="privacyPolicyUrl" target="_blank"
        >Privacy Policy</a
      >
      <a class="ml-3 text-gray-400" [href]="cookiePolicyUrl" target="_blank"
        >Cookie Policy</a
      >
      <a class="ml-3 text-gray-400" [href]="contactUrl" target="_blank"
        >Contact</a
      >
    </span>
  </div>
</footer>
